import { faMasksTheater } from '@fortawesome/pro-solid-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-common-types';

export interface CommandPaletteItem {
    label: string;
    href: string;
    icon: IconDefinition | null;
    section?: string;
    target: string | null;
    onClick?: () => void;
}

export function paletteCommands(): CommandPaletteItem[] {
    const commands: CommandPaletteItem[] = [];

    if (Spark.isPlatformAdmin) {
        commands.push({
            label: 'Kiosk',
            href: '/kiosk',
            icon: faMasksTheater,
            target: null,
        });
    }

    return commands;
}
